import type { BaseEnumModel } from "@edaz/services/baseEnumService";
import type { EntityValidationRules } from "../services/validationService";

export interface IEnum extends BaseEnumModel {
  name: string;
  code: string;
}

export default class Enum implements IEnum {
  id: number | string;
  code: string;
  name: string;
}

export const EnumValidationRules: EntityValidationRules<Enum> = {
  name: {
    required: true,
  },
};
